<template>
  <v-btn
    fab
    x-small
    color="primary"
    class="ma-2"
    v-if="$store.state.mode.helpEnabled"
    @click="showHelp(article)"
  >
    <span class="question-mark">?</span>
  </v-btn>
</template>

<script>
import request from '@/API/';
export default {
  name: "Help",
  props: {
    article: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$root.$on("saveHelp", this.saveSnippet);
  },
  methods: {
    showHelp(article) {
      let self = this;
      request
        .get(
          "https://apio.rocks/api/snippets/360006061202/" +
            encodeURIComponent(article)
        )
        .then((res) => {
          self.$store.commit("toggle", "helpShown");
          self.$store.commit("set", [
            "helpContent",
            {
              shortName: article,
              title: res.data.title,
              body: res.data.body,
              content: res.data.content,
            },
          ]);
        })
        .catch((err) => {
          console.log(err);
          self.$store.commit("toggle", "helpShown");
          self.$store.commit("set", [
            "helpContent",
            {
              shortName: article,
              title: "New Article",
              body:
                "Write the " +
                article +
                " (cmd, ctrl or shift + enter for new lines in editor)",
            },
          ]);
        });
    },
    saveSnippet(article) {
      request
        .post(
          "https://apio.rocks/api/snippets/360006061202/" +
            encodeURIComponent(article.shortName),
          {
            title: article.title,
            content: JSON.stringify(article.content),
            body: article.body,
          }
        )
        .then(() => {
          self.$store.commit("toggle", "helpShown");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.question-mark {
  font-weight: var(--font-semi-bold);
  font-size: 16px;
}
</style>
